@use '@lib/assets/styles/main.scss' as *;

.platformSwitcher {
  z-index: $zIndexDropDown;
  position: relative;
  border-radius: 20px;
  min-width: 172px;
  &:not(.platformSwitcherOpened) {
    border: 1px solid $gray100;
    background-color: $gray0;
    transition: background-color 0.2s ease;
    &:hover {
      background-color: $gray10;
    }
    &:active {
      background-color: $blue50;
    }
  }
}

.platformSwitcherOpened {
  border: 1px solid transparent;
  display: block;
}

.platformSwitcherIcon {
  color: $gray400;
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  & * {
    display: block;
  }
  .platformSwitcherOpened & {
    opacity: 0;
  }
}

.platformSwitcherValue {
  position: relative;
  z-index: 1;
}

.platformSwitcherDropDown {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border: 1px solid $gray100;
  background-color: $gray10;
  padding-top: 40px;
  border-radius: 20px;
  box-shadow: 0 1px 2px 0 rgba($gray1000, 0.30), 0 2px 6px 2px rgba($gray1000, 0.15);
  overflow: hidden;
  .platformSwitcherOpened & {
    display: block;
  }
}

.platformItem {
  width: 100%;
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 8px;
  align-items: center;
  text-align: left;
  padding: 8px 44px 8px 8px;
  background: transparent;
  border: none;
  .platformSwitcherDropDown & {
    background-color: $gray0;
    border-top: 1px solid $gray100;
    padding: 8px;
    &:hover {
      background-color: $gray10;
    }
    &:active {
      background-color: $blue50;
    }
  }
}

.platformItemText {
  color: $gray900;
}

.platformItemIcon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $gray0;
}

.platformItemIconGreen {
  @extend .platformItemIcon;
  background: linear-gradient(35deg, #00B67A 15.79%, #047E56 80.31%);
}

.platformItemIconBlue {
  @extend .platformItemIcon;
  background: linear-gradient(35deg, #214EEB 48.05%, #132E94 80.31%);
}
